import {TextInput} from "react-native";
import Page from "@/lib/components/Page";
import Center from "@/lib/components/Center";
import Header from "@/lib/components/Header";
import globstyles from "@/lib/globstyles";
import {Color} from "@/lib/styles";
import {useState} from "react";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import {fetchBackend} from "@/lib/backend";
import {useSession} from "@/lib/auth/auth";
import {EditEventRequest, EventHappening} from "@/lib/types";
import {useRouter} from "expo-router";
import ErrorMessage from "@/lib/components/ErrorMessage";
import Message from "@/lib/components/Message";
import {useQueryClient} from "@tanstack/react-query";

export default function Create() {
    const {session} = useSession();
    const router = useRouter();
    const queryClient = useQueryClient();

    const [name, setName] = useState("");
    const [error, setError] = useState<Error | null>(null);
    const [busy, setBusy] = useState(false);

    async function submitEvent() {
        setError(null);
        setBusy(true);
        const request: EditEventRequest = {title: name};
        fetchBackend<EventHappening>(`/event`, "POST", session, request).then(async (event) => {
            await queryClient.invalidateQueries({queryKey: ['event', session]});
            router.replace(`/e/${event.event_id}/edit`);
        }).catch((error) => {
            setError(error);
        }).finally(() => {
            setBusy(false);
        });
    }

    return (
        <Page>
            <Center width={330} style={{gap: 16}}>
                <Header title={"Skap et nytt event"} center={true}/>
                <Message
                    text={"Lag et arrangement og inviter dine gjester."}/>
                <TextInput style={[globstyles.formTextInput]}
                           placeholder={"Hva skal eventet hete?"}
                           placeholderTextColor={Color.FadedText}
                           value={name}
                           onChangeText={(text) => {
                               setName(text);
                           }}
                           inputMode={"search"}
                           returnKeyType={"search"}
                           enablesReturnKeyAutomatically={true}
                           autoFocus={true}
                           focusable={true}
                           keyboardAppearance={"dark"}
                           submitBehavior={"submit"}
                           onSubmitEditing={submitEvent}
                />
                {error && <ErrorMessage error={error}/>}
                <Nav>
                    <ActionButton
                        onPress={submitEvent}
                        title={"Lagre og tilpass"}
                        icon={"edit"}
                        busy={busy}
                    />
                </Nav>
            </Center>
        </Page>
    )
}